import { useState, useEffect } from 'react';
import { PLAYER_URL } from '../constants';

interface VideoPlayerPageProps {
    url: string;
    type: string;
    streamKey?: string;
}

export default function VideoPlayerPage({ url, type, streamKey }: VideoPlayerPageProps) {
    const [urlState, setUrlState] = useState('');
    useEffect(() => {
        if (type === 'SECURE_V2') {
            setUrlState(url + 'master.m3u8');
        }
        if (type === 'YOUTUBE') {
            setUrlState(url);
        }
    }, [url, type]);
    const streamUrl = streamKey && `${PLAYER_URL}/live/${streamKey}`;
    const videoUrl = `${PLAYER_URL}/new?url=${encodeURIComponent(
        type === 'YOUTUBE' ? urlState : urlState.replace('.m3u8', '.mpd'),
    )}&type=${type === 'YOUTUBE' ? 'YOUTUBE' : 'SECURE'}`;
    return (
        <>
            <div className="relative w-full aspect-video md:min-h-[70vh] md:aspect-auto">
                <iframe
                    src={streamUrl ? streamUrl : videoUrl}
                    className="absolute inset-0 w-full h-full"
                    frameBorder="0"
                    allow="autoplay; picture-in-picture"
                    allowFullScreen
                />
            </div>
        </>
    );
}
